import { Vehicle } from '@/types'
import VehicleProgramCard from './VehicleProgramCard'
import DeviceProgramCards from '@/app/components/ProgramCards/DeviceProgramCards'

type Props = {
  vehicle: Vehicle
}

const ProgramTab = (props: Props) => {
  return (
    <section className={'flex flex-col w-full gap-4'}>
      <DeviceProgramCards />
      <div id="schedule-vehicle-programs-tab" className="flex flex-col w-full">
        <VehicleProgramCard vehicle={props.vehicle} />
      </div>
    </section>
  )
}

export default ProgramTab
